import z from "zod";
import { availableEmbeddingProviders } from "../../../types/providers/embedding-provider";

export const availableEmbeddingProvidersValidator = z.object({
    EMBEDDING_PROVIDER: z.enum(availableEmbeddingProviders).default("azure"),
})

export const azureEmbeddingProviderValidator = z.object({
  AZURE_OPENAI_EMBEDDING_API_KEY: z.string().min(1, "required").optional(),
  AZURE_OPENAI_EMBEDDING_API_INSTANCE_NAME: z.string().min(1, "required").optional(),
  AZURE_OPENAI_EMBEDDING_API_VERSION: z.string().min(1, "required").optional(),
  AZURE_OPENAI_EMBEDDING_API_DEPLOYMENT_NAME: z.string().min(1, "required").optional(),
  AZURE_OPENAI_EMBEDDING_DIMENSIONS: z.number().min(1).optional(),
});

export const ollamaEmbeddingProviderValidator = z.object({
  OLLAMA_EMBEDDING_BASE_URL: z.string().url().optional(),
  OLLAMA_EMBEDDING_MODEL: z.string().min(1, "required").optional(),
});

export const junetEmbeddingProviderValidator = z.object({
  JUNET_EMBEDDING_BASE_URL: z.string().url().optional(),
  JUNET_EMBEDDING_API_KEY: z.string().optional(),
  JUNET_EMBEDDING_MODEL: z.string().min(1, "required").optional(),
});
